import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-default-redirect',
  template: ''
})
export class DefaultRedirectComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const workOrderUuid = this.activatedRoute.snapshot.queryParamMap.get('open_work_order')?.trim() || '';
    const requestedTab = this.activatedRoute.snapshot.queryParamMap.get('tab')?.trim().toLowerCase() || 'white-glove';
    const isValidWorkOrderUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(workOrderUuid);
    const tab = /^[a-z0-9-]+$/.test(requestedTab) ? requestedTab : 'white-glove';

    if (isValidWorkOrderUuid) {
      void this.router.navigate(['/work_order_details', workOrderUuid], {
        queryParams: { tab },
        replaceUrl: true
      });
      return;
    }

    this.authService.ensureCurrentUserLoaded().subscribe({
      next: (currentUser) => {
        this.router.navigateByUrl(this.authService.getDefaultRoute(currentUser), { replaceUrl: true });
      },
      error: () => {
        this.router.navigateByUrl(this.authService.fallbackDefaultRoute, { replaceUrl: true });
      }
    });
  }
}
